// Mock data for Zona Libre clone

export const categories = [
  { id: 1, name: 'Tecnología', icon: 'Laptop', image: 'https://images.unsplash.com/photo-1605602079417-ae32b68599d9?w=300&q=80', subcategories: ['Celulares', 'Computación', 'Cámaras', 'Audio'] },
  { id: 2, name: 'Vehículos', icon: 'Car', image: 'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=300&q=80', subcategories: ['Autos', 'Motos', 'Repuestos', 'Accesorios'] },
  { id: 3, name: 'Inmuebles', icon: 'Home', image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=300&q=80', subcategories: ['Casas', 'Departamentos', 'Locales', 'Terrenos'] },
  { id: 4, name: 'Hogar y Muebles', icon: 'Sofa', image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=300&q=80', subcategories: ['Muebles', 'Jardín', 'Decoración', 'Electrodomésticos'] },
  { id: 5, name: 'Deportes', icon: 'Dumbbell', image: 'https://images.unsplash.com/photo-1461896836934-bd45ba8fcf9b?w=300&q=80', subcategories: ['Fitness', 'Ciclismo', 'Fútbol', 'Running'] },
  { id: 6, name: 'Moda', icon: 'Shirt', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=300&q=80', subcategories: ['Ropa', 'Calzado', 'Accesorios', 'Relojes'] },
  { id: 7, name: 'Juguetes', icon: 'Gamepad2', image: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=300&q=80', subcategories: ['Bebés', 'Niños', 'Juegos de mesa', 'Videojuegos'] },
  { id: 8, name: 'Herramientas', icon: 'Wrench', image: 'https://images.unsplash.com/photo-1581147036324-c1a0fb40e906?w=300&q=80', subcategories: ['Construcción', 'Industria', 'Jardín', 'Electricidad'] }
];

export const products = [
  {
    id: 1,
    title: 'iPhone 15 Pro Max 256GB',
    price: 1299990,
    originalPrice: 1499990,
    discount: 13,
    images: [
      'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=500&q=80',
      'https://images.unsplash.com/photo-1695048133412-0b8b8f6e4c3f?w=500&q=80',
      'https://images.unsplash.com/photo-1695048117832-a610e873f0e2?w=500&q=80'
    ],
    category: 'Tecnología',
    subcategory: 'Celulares',
    rating: 4.8,
    reviews: 1250,
    seller: 'TechStore oficial',
    sellerId: 1,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: true,
    stock: 45,
    sold: 230,
    description: 'iPhone 15 Pro Max con chip A17 Pro, cámara de 48MP y pantalla Super Retina XDR de 6.7 pulgadas.',
    features: ['256GB almacenamiento', 'Titanio Natural', 'Cámara 48MP', 'Chip A17 Pro', 'USB-C'],
    featured: true,
    questions: [
      {
        id: 1,
        userId: 2,
        userName: 'Carlos López',
        question: '¿Tiene garantía oficial de Apple?',
        answer: 'Sí, incluye garantía oficial de Apple por 1 año',
        answered: true,
        date: '2024-01-20'
      },
      {
        id: 2,
        userId: 3,
        userName: 'María García',
        question: '¿Viene desbloqueado para cualquier operadora?',
        answer: 'Sí, viene liberado para usar con cualquier operadora',
        answered: true,
        date: '2024-01-22'
      },
      {
        id: 3,
        userId: 4,
        userName: 'Juan Pérez',
        question: '¿Tienen stock en color negro?',
        answer: null,
        answered: false,
        date: '2024-01-25'
      }
    ]
  },
  {
    id: 2,
    title: 'Samsung Galaxy S24 Ultra 512GB',
    price: 1199990,
    originalPrice: null,
    discount: 0,
    images: [
      'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=500&q=80'
    ],
    category: 'Tecnología',
    subcategory: 'Celulares',
    rating: 4.9,
    reviews: 890,
    seller: 'Samsung Store',
    sellerId: 2,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: false,
    stock: 30,
    sold: 156,
    description: 'Samsung Galaxy S24 Ultra con S Pen integrado, cámara de 200MP y pantalla Dynamic AMOLED 2X.',
    features: ['512GB almacenamiento', 'S Pen incluido', 'Cámara 200MP', 'AI avanzada', '12GB RAM'],
    featured: true,
    questions: []
  },
  {
    id: 3,
    title: 'MacBook Pro 14" M3 Pro 18GB RAM',
    price: 2499990,
    originalPrice: 2799990,
    discount: 11,
    images: [
      'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=500&q=80'
    ],
    category: 'Tecnología',
    subcategory: 'Computación',
    rating: 5.0,
    reviews: 567,
    seller: 'Apple Premium',
    sellerId: 3,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: true,
    stock: 12,
    sold: 89,
    description: 'MacBook Pro con chip M3 Pro, pantalla Liquid Retina XDR y hasta 22 horas de batería.',
    features: ['18GB RAM', '512GB SSD', 'Chip M3 Pro', 'Pantalla 14.2"', 'Space Black'],
    featured: true,
    questions: []
  },
  {
    id: 4,
    title: 'Sony WH-1000XM5 Auriculares Bluetooth',
    price: 349990,
    originalPrice: 429990,
    discount: 19,
    images: [
      'https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=500&q=80'
    ],
    category: 'Tecnología',
    subcategory: 'Audio',
    rating: 4.7,
    reviews: 2341,
    seller: 'AudioPro',
    sellerId: 4,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: false,
    stock: 78,
    sold: 456,
    description: 'Auriculares con cancelación de ruido líder en la industria y sonido premium.',
    features: ['Cancelación de ruido', '30hrs batería', 'Bluetooth 5.2', 'Sonido Hi-Res', 'Plegables'],
    featured: false,
    questions: []
  },
  {
    id: 5,
    title: 'PlayStation 5 Slim 1TB + 2 Juegos',
    price: 599990,
    originalPrice: 699990,
    discount: 14,
    images: [
      'https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=500&q=80'
    ],
    category: 'Tecnología',
    subcategory: 'Videojuegos',
    rating: 4.9,
    reviews: 1876,
    seller: 'GameZone oficial',
    sellerId: 5,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: true,
    stock: 25,
    sold: 312,
    description: 'Consola PS5 Slim con 1TB de almacenamiento, incluye 2 juegos AAA.',
    features: ['1TB almacenamiento', '2 juegos incluidos', '4K/120fps', 'Ray tracing', 'Control DualSense'],
    featured: true,
    questions: []
  },
  {
    id: 6,
    title: 'Smart TV Samsung 55" QLED 4K',
    price: 899990,
    originalPrice: 1099990,
    discount: 18,
    images: [
      'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=500&q=80'
    ],
    category: 'Tecnología',
    subcategory: 'Televisores',
    rating: 4.6,
    reviews: 987,
    seller: 'ElectroHogar',
    sellerId: 6,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: false,
    stock: 34,
    sold: 201,
    description: 'Smart TV QLED con tecnología Quantum Dot y sistema operativo Tizen.',
    features: ['55 pulgadas', 'QLED 4K', 'HDR10+', 'Smart TV', 'Alexa integrada'],
    featured: false,
    questions: []
  },
  {
    id: 7,
    title: 'Bicicleta Mountain Bike Rodado 29"',
    price: 459990,
    originalPrice: null,
    discount: 0,
    images: [
      'https://images.unsplash.com/photo-1576435728678-68d0fbf94e91?w=500&q=80'
    ],
    category: 'Deportes',
    subcategory: 'Ciclismo',
    rating: 4.5,
    reviews: 456,
    seller: 'BikeWorld',
    sellerId: 7,
    condition: 'Nuevo',
    freeShipping: false,
    fullDiscount: false,
    stock: 15,
    sold: 89,
    description: 'Mountain bike profesional con suspensión completa y cambios Shimano.',
    features: ['Rodado 29', 'Suspensión full', 'Shimano 21vel', 'Frenos disco', 'Aluminio'],
    featured: false,
    questions: []
  },
  {
    id: 8,
    title: 'Zapatillas Nike Air Max 2024',
    price: 149990,
    originalPrice: 189990,
    discount: 21,
    images: [
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500&q=80'
    ],
    category: 'Moda',
    subcategory: 'Calzado',
    rating: 4.8,
    reviews: 3421,
    seller: 'Nike Store',
    sellerId: 8,
    condition: 'Nuevo',
    freeShipping: true,
    fullDiscount: true,
    stock: 120,
    sold: 892,
    description: 'Zapatillas deportivas con tecnología Air Max y diseño moderno.',
    features: ['Air Max', 'Múltiples tallas', 'Varios colores', 'Mesh transpirable', 'Suela de goma'],
    featured: true,
    questions: []
  }
];

export const banners = [
  {
    id: 1,
    title: 'Ofertas de la Semana',
    subtitle: 'Hasta 50% OFF en tecnología',
    image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1200&q=80',
    cta: 'Ver ofertas',
    link: '/ofertas'
  },
  {
    id: 2,
    title: 'Envío Gratis',
    subtitle: 'En miles de productos',
    image: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=1200&q=80',
    cta: 'Descubrir',
    link: '/envio-gratis'
  },
  {
    id: 3,
    title: 'Moda 2025',
    subtitle: 'Las últimas tendencias',
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1200&q=80',
    cta: 'Comprar ahora',
    link: '/moda'
  }
];

export const mockUser = {
  id: 1,
  name: 'Usuario Demo',
  email: 'demo@zonalibre.com',
  role: 'buyer', // buyer, seller, advertiser
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Demo',
  reputation: 4.8,
  sales: 0,
  purchases: 12
};

export const mockOrders = [
  {
    id: 'ZL-2024-001',
    date: '2024-01-15',
    status: 'Entregado',
    total: 349990,
    items: [
      { productId: 4, quantity: 1, price: 349990 }
    ]
  },
  {
    id: 'ZL-2024-002',
    date: '2024-01-20',
    status: 'En camino',
    total: 149990,
    items: [
      { productId: 8, quantity: 1, price: 149990 }
    ]
  }
];
